import { StarIcon } from "@heroicons/react/24/outline";
import { StarIcon as StarIconSolid } from "@heroicons/react/24/solid";

import { Label } from "@fronterahealth/frontera-ui-components";

interface SessionRatingProps {
  shortView: boolean;
  rating: number;
}

export const SessionRating: React.FC<SessionRatingProps> = ({ shortView, rating }) => {
  return (
    <div className="flex justify-center">
      {!shortView ? (
        <div className="flex justify-center items-center px-2 py-1 w-28 h-6 border border-gray-300 rounded-2xl">
          <div className="flex items-center gap-1">
            {[...Array(5)].map((_, i) => (
              <StarIcon key={i} height={16} fill={i < rating ? "grey" : "none"} color="grey" />
            ))}
          </div>
        </div>
      ) : (
        <div className="flex flex-row items-center gap-2">
          <span className="w-1 h-1 bg-gray-500 rounded-full"></span>

          <div className="flex flex-row gap-0.5 items-center">
            <StarIconSolid className="text-yellow-500 w-3 h-3" color="grey" />
            <Label size="extra-small">{rating}</Label>
          </div>
        </div>
      )}
    </div>
  );
};
